module.exports = __webpack_public_path__ + "static/template-preview-7b1fa063c5d33b2fb406dc8789797c18.png";